(() => {
  document.querySelectorAll('[data-hipster-filters]').forEach(filters => {
    filters.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      filters.querySelectorAll('button').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
      let count = 0;
      document.querySelectorAll('[data-hipster-category]').forEach(card => {
        card.hidden = button.dataset.filter !== 'todos' && card.dataset.hipsterCategory !== button.dataset.filter;
        if (!card.hidden) count++;
      });
      const status = document.querySelector('[data-hipster-count]');
      if (status) status.textContent = `${count} produtos nesta seleção`;
    }));
  });
  // Reload this PDP with the selected variant so every image, label and JSON-LD
  // is rendered from the same verified SKU. Common purchase script updates first.
  if (location.pathname.endsWith('/shampoo-anticaspa-hipster-250ml') && document.body.classList.contains('bf-hipster-pdp')) {
    document.querySelector('[data-bf-variant]')?.addEventListener('change', event => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.replace(url.href);
    });
  }
})();
